import type { TAutomationQueryParams } from "./types";

export const apiKeysKeys = {
  all: ["api-keys"] as const,
  apiKeys: ["api-keys", "list"] as const,
  apiUsage: ["api-keys", "usage"] as const,
  automation: (params: TAutomationQueryParams) =>
    ["api-keys", "automation", params] as const,
};
